<div class="section border-bottom">
    <div class="video flex-1 d-flex p-1">
        @if (!media && !errorMessage) {
            <div class="loader d-flex flex-stretch justify-content-center align-items-center">
                <kui-loader> </kui-loader>
            </div>
        }

        <kui-alert-panel [size]="3" [message]="errorMessage"></kui-alert-panel>

        @if (media) {
            @switch (media.type) {
                @case ("video") {
                    @if (!errorMessage) {
                        <key-video [asset]="asset" [video]="media" [controls]="true" [download]="false"></key-video>
                    }
                }
                @case ("image") {
                    @if (!errorMessage) {
                        <img [src]="media.url" (error)="onImageError($event)" class="image" />
                    }
                }
            }
        }
    </div>
</div>
